import React, { useEffect, useState, useRef } from 'react';

const StatsCounter = ({ type = 'university' }) => {
  const [counts, setCounts] = useState([0, 0, 0, 0]);
  const [hasAnimated, setHasAnimated] = useState(false);
  const sectionRef = useRef(null);
  const timersRef = useRef([]);

  const universityStats = [
    { value: 10, label: "Estudiantes Inscritos", suffix: "+" },
    { value: 99, label: "Tasa de Satisfacción", suffix: "%" },
    { value: 10, label: "Sesiones Intensivas", suffix: "" },
    { value: 24, label: "Soporte", suffix: "/7" }
  ];

  const modelStats = [
    { value: 50, label: "Modelos Activas", suffix: "+" },
    { value: 5, label: "Años de Experiencia", suffix: "+" },
    { value: 15, label: "Ingresos Promedio (K/mes)", suffix: "K" },
    { value: 24, label: "Soporte", suffix: "/7" }
  ];

  const stats = type === 'university' ? universityStats : modelStats;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          animateCounters();
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      // Clean up all timers
      timersRef.current.forEach(timer => clearInterval(timer));
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const animateCounters = () => {
    const duration = 2000; // 2 seconds
    const incrementTime = 50;
    const steps = duration / incrementTime;

    stats.forEach((stat, index) => {
      let currentValue = 0;
      const increment = stat.value / steps;

      const timer = setInterval(() => {
        currentValue += increment;
        
        if (currentValue >= stat.value) {
          // Set final value and clear timer
          setCounts(prev => {
            const newCounts = [...prev];
            newCounts[index] = stat.value;
            return newCounts;
          });
          clearInterval(timer);
        } else {
          setCounts(prev => {
            const newCounts = [...prev];
            newCounts[index] = Math.floor(currentValue);
            return newCounts;
          });
        }
      }, incrementTime);

      timersRef.current.push(timer);
    });
  };

  return (
    <section ref={sectionRef} className="py-12 md:py-16 px-4 bg-black/40">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="text-center p-4"
            >
              <span className="text-4xl md:text-5xl font-bold text-[#c8784e]">
                {counts[index]}{stat.suffix}
              </span>
              <p className="text-gray-400 text-xs md:text-sm mt-2 font-medium">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsCounter;
